import { take } from 'lodash';
import styled from 'styled-components';

import { user } from '../lib/config/roles-and-permissions';
import { Spacer } from './spacer';
import { Avatar, AvatarAndMore } from './styled/avatar';
import { Annotation } from './styled/text';

const AlsoGoingWrapper = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${(props) => props.theme.stroke};
`;

const Avatars = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  div {
    margin-left: -0.75rem;
  }
  div:first-of-type {
    margin-left: 0;
  }
`;

export function AlsoGoing({ users }) {
  const recents = take(users, 5);

  if (!users.length) {
    return (
      <AlsoGoingWrapper>
        <Annotation>Wie zijn erbij?</Annotation>
        <Spacer size={0.25} />
        <Avatars>
          <AvatarAndMore>0</AvatarAndMore>
          <Spacer size={0.5} />
          <Annotation>Meld je als eerste aan</Annotation>
        </Avatars>
      </AlsoGoingWrapper>
    );
  }

  return (
    <AlsoGoingWrapper>
      <Annotation>Wie zijn erbij?</Annotation>
      <Spacer size={0.25} />
      <Avatars>
        {recents.map((user) =>
          user?.profile?.avatar?.url ? (
            <Avatar small key={user.id} src={user.profile.avatar.url} />
          ) : (
            <Avatar small key={user.id} src={'/icons/placeholder-avatar.svg'} />
          )
        )}
        {users.length > 5 && <AvatarAndMore>+{users.length - 5}</AvatarAndMore>}
        <Spacer size={0.5} />
        <Annotation>zijn erbij</Annotation>
      </Avatars>
    </AlsoGoingWrapper>
  );
}
